export default "__VITE_ASSET__D4Ji4946__"